import axios from 'axios';

export const fetchUsers = async (setUsers, setError, setLoading) => {
    try {
        const response = await axios.get('https://adapt-api.softmining.it/users', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });

        setUsers(response.data.data);
    } catch (err) {
        setError(err.response?.data?.message || err.message);
    } finally {
        setLoading(false);
    }
};